import { render, staticRenderFns } from "./SubscriptionDocument.vue?vue&type=template&id=ddf2148c&scoped=true&"
import script from "./SubscriptionDocument.vue?vue&type=script&lang=js&"
export * from "./SubscriptionDocument.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionDocument.vue?vue&type=style&index=0&id=ddf2148c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf2148c",
  null
  
)

export default component.exports